// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-card-body p[data-v-733dcf74] {\n  padding-bottom: 1rem;\n}\n.pad-right[data-v-733dcf74] {\n  margin-right: 1rem;\n}\n.modal-card-body[data-v-733dcf74] {\n  position: relative;\n}\n.modal-card-body .close-modal[data-v-733dcf74] {\n  position: absolute;\n  right: 20px;\n  top:20px;\n  width: 40px;\n}\n.modal-title[data-v-733dcf74] {\n  color: #00CCD1;\n  font-weight:500;\n}\n", ""]);
// Exports
module.exports = exports;
